var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Spin } from '@components';
import { mainRouterList, loginRouterList, residentScheduleOptimizationList } from '@router/layout/config';
import { inject, observer } from 'mobx-react';
import { HeaderBusiness } from '@business/common/header';
import { combine } from 'fe-toolkit';
import { AccountBusiness } from '@business/account/login';
import PubSub from '@common/utils/pubsub';
var Loading = React.createElement(Spin, { style: { position: 'fixed', left: 0, right: 0, top: 0, bottom: 0 } });
var withWrap = function (loader) {
    var Loader = /** @class */ (function (_super) {
        __extends(Loader, _super);
        function Loader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Loader.prototype.componentDidMount = function () {
            this.updateBodyClass();
        };
        Loader.prototype.componentDidUpdate = function () {
            this.updateBodyClass();
        };
        Loader.prototype.updateBodyClass = function () {
            var clientInfo = this.props.clientInfo;
            if (clientInfo.clientCode && !document.body.classList.contains(clientInfo.clientCode)) {
                document.body.classList.add(clientInfo.clientCode);
            }
        };
        Loader.prototype.render = function () {
            var _a = this.props, currentUser = _a.currentUser, location = _a.location;
            return currentUser.userName || location.pathname.toLowerCase().startsWith('/account') ?
                React.createElement(loader, this.props) : Loading;
        };
        Loader = __decorate([
            inject(combine(HeaderBusiness, AccountBusiness)),
            observer
        ], Loader);
        return Loader;
    }(React.Component));
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.prototype.componentDidMount = function () {
            var _a = this.props, match = _a.match, toggleMenu = _a.toggleMenu, menuShow = _a.menuShow, setTitle = _a.setTitle, showBack = _a.showBack, location = _a.location, hideToggler = _a.hideToggler, hideHeader = _a.hideHeader, getRatingToggle = _a.getRatingToggle;
            // Routes outside mainRouterList/loginRouterList (e.g. the top-level
            // anonymous ones in router/index.tsx) have no config; fall back to defaults.
            var config = mainRouterList.concat(loginRouterList).filter(function (i) { return i.path === match.path; })[0] || {};
            config.title && (document.title = config.title);
            menuShow && toggleMenu();
            config.isHideHeader ? hideHeader(true) : hideHeader(false);
            config.titleBar ? setTitle(config.titleBar) : setTitle('');
            config.isShowBack ? showBack(true) : showBack(false);
            config.isHideToggler ? hideToggler(true) : hideToggler(false);
            window.ga && window.ga('send', 'pageview', "" + location.pathname + location.search);
            PubSub.notify('scrollto', 0);
            !residentScheduleOptimizationList.some(function (x) { return window.location.href.toLowerCase().includes(x.path.toLowerCase()); }) && getRatingToggle();
        };
        Wrapper.prototype.shouldComponentUpdate = function () {
            return false;
        };
        Wrapper.prototype.render = function () {
            return React.createElement(React.Suspense, { fallback: Loading }, React.createElement(withRouter(Loader), this.props));
        };
        Wrapper = __decorate([
            inject(HeaderBusiness)
        ], Wrapper);
        return Wrapper;
    }(React.Component));
    return Wrapper;
};
export var Home = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'home' */
'./home'); }));
export var Login = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'account' */
'./login'); }));
export var SignUp = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'account' */
'./signUp'); }));
export var SignUpByEmail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'account' */
'./signUpByEmail'); }));
export var ResetPassword = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'account' */
'./resetPassword'); }));
export var ResetPasswordByEmail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'account' */
'./resetPasswordByEmail'); }));
export var ServiceHistory = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceHistory' */
'./serviceHistory'); }));
export var ScheduledService = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'scheduledService' */
'./scheduledService'); }));
export var Messages = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'messages' */
'./messages'); }));
export var Procare = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'procare' */
'./procare'); }));
export var CreateProcare = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'procare' */
'./createProcare'); }));
export var ServiceRating = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'./serviceRating'); }));
export var RequestRepairServiceCategory = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/serviceCategory'); }));
export var AiRequestRepairServiceCategory = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/aiServiceCategory'); }));
export var RequestRepairServiceType = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/serviceType'); }));
export var RequestRepairServiceCode = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/serviceCode'); }));
export var RequestRepairDetail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/createWO'); }));
export var RequestConfirmation = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/confirmation'); }));
export var RepairSuccess = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'requestRepair' */
'./requestRepair/repairSuccess'); }));
export var MaintenanceHowTo = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'guide' */
'./maintenanceHowTo'); }));
export var Details = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'details' */
'./detail'); }));
export var RatingDetail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'./rating/ratingDetail'); }));
export var RatingSuccess = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'./rating/ratingSuccess'); }));
export var RatingFailed = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'./rating/ratingFail'); }));
export var RatingCompleted = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'./rating/ratingCompleted'); }));
export var WORatingDetail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'serviceRating' */
'../../containers/woRating/index'); }));
export var ContactUs = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./contactUs'); }));
export var UserProfile = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./userProfile'); }));
export var VideoList = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'guide' */
'./traningResources/videoList'); }));
export var GuideList = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'guide' */
'./traningResources/guideList'); }));
export var VideoDetail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'guide' */
'./traningResources/videoDetail'); }));
export var GuideDetail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'guide' */
'./traningResources/guideDetail'); }));
export var PrivacyStatement = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./privacyStatement'); }));
export var UsePolicy = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./usePolicy'); }));
export var TextTerms = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./textTerms'); }));
export var Agreement = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./agreement'); }));
export var EmailToSchedule = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./emailToSchedule'); }));
export var ResidentEmailToSchedule = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./emailToSchedule/ResidentEmailToSchedule'); }));
export var ResidentEmailScheduleSuccess = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./emailToSchedule/ResidentEmailScheduleSuccess'); }));
export var EmailToScheduleSuccess = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'setting' */
'./emailToSchedule/scheduleSuccess'); }));
export var ProposedTimwForWO = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'proposedTimwForWO' */
'./proposedTimeForWO'); }));
export var CallApp = React.lazy(function () { return import(
/* webpackChunkName: 'callApp' */
'./callApp'); });
export var AppPromotion = React.lazy(function () { return import(
/* webpackChunkName: 'AppPromotion' */
'./appPromotion'); });
export var NewRSPIndex = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'NewRSPIndex' */
'../../containers/newCreateRequest'); }));
export var CreateSteps = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'CreateSteps' */
'../../containers/newCreateRequest/stepsItems'); }));
export var Download = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'CreateSteps' */
'../../containers/home/appPromotion/AppDownload'); }));
export var AppointmentDetails = React.lazy(function () { return import(
/* webpackChunkName: 'AppointmentDetails' */
'./appointmentDetails/index'); });
export var CompleteAccount = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'CompleteAccount' */
'./completeAccount'); }));
export var ResetPasswordInfo = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'ResetPasswordInfo' */
'./resetPasswordInfo'); }));
export var CheckLogin = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'CheckLogin' */
'./checkLogin'); }));
export var SSOLoginError = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'SSOLoginError' */
'./ssoLoginError'); }));
export var RefreshPage = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'RefreshPage' */
'./refreshPage'); }));
export var HPALoginError = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'HPALoginError' */
'./hpaLoginError'); }));
export var ForgotPasswordByUserName = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'ForgotPasswordByUserName' */
'./forgotPasswordByUserName'); }));
export var AppSsoSuccess = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'AppSsoSuccess' */
'./appSsoSuccess'); }));
export var ErrorPage = React.lazy(function () { return import(
/* webpackChunkName: 'ErrorPage' */
'./errorPage'); });
export var VerifyEmail = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'VerifyEmail' */
'./verifyEmail'); }));
export var SignInOneTimeCode = withWrap(React.lazy(function () { return import(
/* webpackChunkName: 'SignInOneTimeCode' */
'./signInOneTimeCode'); }));
